// Exposes the exports for file.js to the global context on property "libraryName".
// In web browsers, window.libraryName is then available.
require('expose-loader?React!react');

require('expose-loader?ReactDOM!react-dom');

require('expose-loader?PropTypes!prop-types');

require('expose-loader?moment!moment');

require('expose-loader?ReactBootstrapTable!react-bootstrap-table-next');

require('expose-loader?ReactRedux!react-redux');

require('expose-loader?ReactRouterRedux!react-router-redux');

require('expose-loader?Redux!redux');

require('expose-loader?ReduxJsonApi!redux-json-api');

require('expose-loader?i18nextFoundry!i18next');

require('expose-loader?pluralize!pluralize');

require('expose-loader?ahoy!@everfi/foundry-analytics-js'); // these cause engage to break and don't save space until the sdk-web is in use
// require('expose-loader?DesignSystem!@everfi/design-system');
// require('expose-loader?ChakraUI!@chakra-ui/react');
// can't get this one to work, but would be another nice one to include
// require("expose-loader?DomHelpers!dom-helpers");